import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserBalanceService {
  private readonly apiUrl = environment.api.url;

  constructor(private http: HttpClient, private authService: AuthService) {}

  async getBalances(
    page: number = 1,
    count: number = 10,
    query: string,
    order: number,
    showCeros: boolean = false,
    startDate: number = 0,
    endDate: number = 0
  ): Promise<any> {
    const token = await this.authService.getJWTToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      }),
    };
    const params = `?p=${page}&n=${count}&q=${encodeURIComponent(query || '')}&o=${order || 0}&c=${showCeros ? 1 : 0}&s=${startDate}&e=${endDate}`;

    try {
      return await firstValueFrom(
        this.http.get<any>(`${this.apiUrl}/user/wallet/balance${params}`, httpOptions)
          .pipe(timeout(45000)) // 45 seconds timeout
      );
    } catch (error) {
      console.error('Error fetching balances:', error);
      // Return default empty response structure
      return {
        page: 0,
        start: 0,
        end: 0,
        pages: 0,
        rows: [],
        balance: {page: 0, range: 0, total: 0}
      };
    }
  }
}
